import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import jsPDF from 'jspdf';
import { Location } from '@angular/common'; // Import Location
import { Subscription } from 'rxjs';
//import { DataService } from '../data.service'; // Ensure the import path is correct
//import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

@Component({
  selector: 'app-eoipdf',
  templateUrl: './eoipdf.component.html',
  styleUrl: './eoipdf.component.css' // Assuming a SCSS file exists for this component
})
export class EoipdfComponent {
  // Store the form data received from the previous component
  formData: any;
  private historySubscription: any;
  //private dataService: DataService;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private toastr: ToastrService,
    private location: Location, // Inject Location service
    //dataService: DataService,
   
    
  ) { }

  ngOnInit(): void {
    // Retrieve the data from the router's state
    // The data is passed via `history.state` and is available immediately upon navigation
    this.formData = history.state;

    // Check if the formData object is valid and has keys
    if (this.formData && Object.keys(this.formData).length > 0) {
      //console.log('Form data received:', this.formData);
      // Use replaceState to disable the back button
      this.location.replaceState(this.router.url);
      //Listen for 'popstate' events(back button clicks)
      this.historySubscription = this.location.subscribe(() => {
        this.location.forward(); // Pushes the user forward to the current page
      });

    } else {
      // Handle the case where no form data was passed, e.g., if the page was refreshed
      this.toastr.warning('Form data not found. Please resubmit the form.');
      this.router.navigate(['/']); // Redirect to home or form page
    }
  }

  
  ngOnDestroy(): void {
    if (this.historySubscription) {
      this.historySubscription.unsubscribe();
    }
  }
  


  /**
   * Triggers the PDF generation and download.
   * This function will be called when the "Download PDF" button is clicked.
   */
  downloadPdf(): void {
    
    if (this.formData) {    
      
      this.generatePdf(this.formData);
    } else {
      this.toastr.error('No form data available to generate PDF.');
    }
  }


  


  /**
   * Navigates the user back to the login page.
   * This function will be called when the "Return to Login" button is clicked.
   */
  returnToLogin(): void {
    this.router.navigate(['/login']);
  }

  /**
   * Generates a PDF document from the form data using jsPDF.
   *
   * @param formData The form data object to be included in the PDF.
   */
  //ggeneratePdf(formData: any): void {
  //  // Initialize jsPDF with landscape orientation as per your design
  //  const doc = new jsPDF({
  //    orientation: 'landscape',
  //    unit: 'mm',
  //    format: 'a4',
  //  });

  //  // **Page Border**
  //  const margin = 10;
  //  const pageWidth = doc.internal.pageSize.width;
  //  const pageHeight = doc.internal.pageSize.height;
  //  doc.setDrawColor(0); // Black color for the border
  //  doc.setLineWidth(1); // 1mm line width
  //  doc.rect(margin, margin, pageWidth - 2 * margin, pageHeight - 2 * margin); // Draw the rectangle border

  //  // **Logos**
  //  // IMPORTANT: Ensure these paths are correct relative to your project's assets folder
  //  const logo1 = 'assets/Images/RAMP_LOGO.jpg';
  //  const logo2 = 'assets/Images/logo_icon.png';
  //  const imgWidth = 30, imgHeight = 30, imgX1 = 15, imgX2 = 250, imgY = 15;

  //  // Create Image objects for asynchronous loading
  //  const logoImg1 = new Image();
  //  const logoImg2 = new Image();
  //  logoImg1.src = logo1;
  //  logoImg2.src = logo2;

  //  // Use Promise.all to wait for both images to load before adding them to the PDF
  //  Promise.all([
  //    new Promise<void>((resolve) => (logoImg1.onload = () => resolve())),
  //    new Promise<void>((resolve) => (logoImg2.onload = () => resolve())),
  //  ]).then(() => {
  //    // Add loaded images to the PDF
  //    doc.addImage(logoImg1, 'PNG', imgX1, imgY, imgWidth, imgHeight);
  //    doc.addImage(logoImg2, 'PNG', imgX2, imgY, imgWidth, imgHeight);

  //    // **Main Title**
  //    doc.setFont('helvetica', 'bold');
  //    doc.setFontSize(19);
  //    doc.setTextColor(197, 41, 42); // Reddish color
  //    // Center text using pageWidth / 2
  //    doc.text('Maharashtra Small Scale Industries Development Corporation Ltd.', pageWidth / 2, imgY + 5, { align: 'center' });

  //    doc.setFontSize(11);
  //    doc.setTextColor(0, 0, 0); // Black color
  //    doc.text('A Government Of Maharashtra Undertaking', pageWidth / 2, imgY + 12, { align: 'center' });

  //    doc.setFontSize(10);
  //    doc.text('CIN No. U74999MH1962SGC012501', pageWidth / 2, imgY + 18, { align: 'center' });

  //    // **Header Line**
  //    const lineY = imgY + imgHeight + 5; // Position the line below the logos and titles
  //    doc.setDrawColor(0); // Black color for the line
  //    doc.line(margin + 5, lineY, pageWidth - margin - 5, lineY); // Draw a line across the page

  //    // **Acknowledgment/Registration Title**
  //    doc.setFont('helvetica', 'bold');
  //    doc.setFontSize(19);
  //    doc.setTextColor(0, 86, 179); // Blue color
  //    // Center text below the line
  //    doc.text('EOI Registration Details', pageWidth / 2, lineY + 10, { align: 'center' });

  //    // --- Start adding form data below the header ---
  //    let yPos = lineY + 25; // Adjusted starting Y position for form data, leaving space for the header
  //    const xPosContent = 15; // Starting X position for form data text
  //    const lineHeight = 8; // Smaller line height for form data for more items per page

  //    doc.setFontSize(10); // Smaller font for details
  //    doc.setTextColor(0, 0, 0); // Ensure text color is black for form data
  //    doc.setFont('helvetica', 'normal'); // Reset font style to normal for data

  //    // Iterate over the formData object to add each field
  //    for (const key in formData) {
  //      if (formData.hasOwnProperty(key)) {
  //        // Skip keys that represent the actual file object or its temporary path.
  //        if (key.endsWith('File') || key.endsWith('Path')) {
  //          continue; // Skip this iteration, do not add this field to the PDF
  //        }

  //        let value = formData[key];

  //        // Special handling for boolean values (e.g., termsConditionAccepted)
  //        if (typeof value === 'boolean') {
  //          value = value ? 'Yes' : 'No';
  //        } else if (value === null || value === undefined || value === '') {
  //          value = 'N/A'; // Display 'N/A' for empty values
  //        }

  //        const fieldName = this.formatFieldName(key);
  //        const text = `${fieldName}: ${value}`; // Format key for readability

  //        // Check if content will overflow the current page
  //        if (yPos + lineHeight > pageHeight - margin) {
  //          doc.addPage();
  //          // Redraw border and a simplified header on the new page for consistency
  //          doc.setDrawColor(0);
  //          doc.setLineWidth(1);
  //          doc.rect(margin, margin, pageWidth - 2 * margin, pageHeight - 2 * margin);
  //          doc.setFont('helvetica', 'bold');
  //          doc.setFontSize(14); // Slightly smaller title for continued pages
  //          doc.setTextColor(0, 0, 0); // Black for continued title
  //          doc.text('EOI Registration Details (Continued)', pageWidth / 2, margin + 10, { align: 'center' });
  //          doc.setDrawColor(0);
  //          doc.line(margin + 5, margin + 20, pageWidth - margin - 5, margin + 20); // Line below continued title
  //          yPos = margin + 30; // Reset Y position for new page, leaving space for new header
  //          doc.setFontSize(10); // Reset font size for data
  //          doc.setTextColor(0, 0, 0); // Ensure text color is black
  //          doc.setFont('helvetica', 'normal'); // Reset font style
  //        }

  //        doc.text(text, xPosContent, yPos);
  //        yPos += lineHeight;
  //      }
  //    }

  //    // Generate a dynamic filename using the Enterprise Name from the form data
  //    const enterpriseName = formData.EnterpriseName || 'EOI_Registration';
  //    doc.save(`${enterpriseName}_Form_Data.pdf`);
  //    this.toastr.info('Form data downloaded as PDF.');
  //  }).catch(error => {
  //    // Handle errors during image loading or PDF generation
  //    console.error('Error generating PDF (images or content):', error);
  //    this.toastr.error('Failed to generate PDF. Please check image paths or try again.');
  //  });
  //}


  //oldgeneratePdf(formData: any): void {
  //  // Initialize jsPDF with landscape orientation as per your design
  //  const doc = new jsPDF({
  //    orientation: 'landscape',
  //    unit: 'mm',
  //    format: 'a4',
  //  });

  //  // Create a copy of formData and remove the unwanted 'navigationId'
  //  const cleanFormData = { ...formData };
  //  delete cleanFormData['navigationId'];

  //  // **Page Border**
  //  const margin = 10;
  //  const pageWidth = doc.internal.pageSize.width;
  //  const pageHeight = doc.internal.pageSize.height;
  //  doc.setDrawColor(0); // Black color for the border
  //  doc.setLineWidth(1); // 1mm line width
  //  doc.rect(margin, margin, pageWidth - 2 * margin, pageHeight - 2 * margin); // Draw the rectangle border

  //  // **Logos**
  //  // IMPORTANT: Ensure these paths are correct relative to your project's assets folder
  //  const logo1 = 'assets/Images/RAMP_LOGO.jpg';
  //  const logo2 = 'assets/Images/logo_icon.png';
  //  const imgWidth = 30, imgHeight = 30, imgX1 = 15, imgX2 = 250, imgY = 15;

  //  // Create Image objects for asynchronous loading
  //  const logoImg1 = new Image();
  //  const logoImg2 = new Image();
  //  logoImg1.src = logo1;
  //  logoImg2.src = logo2;

  //  // Use Promise.all to wait for both images to load before adding them to the PDF
  //  Promise.all([
  //    new Promise<void>((resolve) => (logoImg1.onload = () => resolve())),
  //    new Promise<void>((resolve) => (logoImg2.onload = () => resolve())),
  //  ]).then(() => {
  //    // Add loaded images to the PDF
  //    doc.addImage(logoImg1, 'PNG', imgX1, imgY, imgWidth, imgHeight);
  //    doc.addImage(logoImg2, 'PNG', imgX2, imgY, imgWidth, imgHeight);

  //    // **Main Title**
  //    doc.setFont('helvetica', 'bold');
  //    doc.setFontSize(19);
  //    doc.setTextColor(197, 41, 42); // Reddish color
  //    // Center text using pageWidth / 2
  //    doc.text('Maharashtra Small Scale Industries Development Corporation Ltd.', pageWidth / 2, imgY + 5, { align: 'center' });

  //    doc.setFontSize(11);
  //    doc.setTextColor(0, 0, 0); // Black color
  //    doc.text('A Government Of Maharashtra Undertaking', pageWidth / 2, imgY + 12, { align: 'center' });

  //    doc.setFontSize(10);
  //    doc.text('CIN No. U74999MH1962SGC012501', pageWidth / 2, imgY + 18, { align: 'center' });

  //    // **Header Line**
  //    const lineY = imgY + imgHeight + 5; // Position the line below the logos and titles
  //    doc.setDrawColor(0); // Black color for the line
  //    doc.line(margin + 5, lineY, pageWidth - margin - 5, lineY); // Draw a line across the page

  //    // **Acknowledgment/Registration Title**
  //    doc.setFont('helvetica', 'bold');
  //    doc.setFontSize(19);
  //    doc.setTextColor(0, 86, 179); // Blue color
  //    // Center text below the line
  //    doc.text('EOI Registration Details', pageWidth / 2, lineY + 10, { align: 'center' });

  //    // --- Start adding form data below the header ---
  //    let yPos = lineY + 25; // Adjusted starting Y position for form data, leaving space for the header
  //    const xPosContent = 15; // Starting X position for form data text
  //    const lineHeight = 8; // Smaller line height for form data for more items per page

  //    doc.setFontSize(10); // Smaller font for details
  //    doc.setTextColor(0, 0, 0); // Ensure text color is black for form data
  //    doc.setFont('helvetica', 'normal'); // Reset font style to normal for data

  //    // Iterate over the formData object to add each field
  //    for (const key in cleanFormData) {
  //      if (cleanFormData.hasOwnProperty(key)) {
  //        // Skip keys that represent the actual file object or its temporary path.
  //        if (key.endsWith('File') || key.endsWith('Path')) {
  //          continue; // Skip this iteration, do not add this field to the PDF
  //        }

  //        let value = cleanFormData[key];

  //        // Special handling for boolean values (e.g., termsConditionAccepted)
  //        if (typeof value === 'boolean') {
  //          value = value ? 'Yes' : 'No';
  //        } else if (value === null || value === undefined || value === '') {
  //          value = 'N/A'; // Display 'N/A' for empty values
  //        }

  //        const fieldName = this.formatFieldName(key);
  //        const text = `${fieldName}: ${value}`; // Format key for readability

  //        // Check if content will overflow the current page
  //        if (yPos + lineHeight > pageHeight - margin) {
  //          doc.addPage();
  //          // Redraw border and a simplified header on the new page for consistency
  //          doc.setDrawColor(0);
  //          doc.setLineWidth(1);
  //          doc.rect(margin, margin, pageWidth - 2 * margin, pageHeight - 2 * margin);
  //          doc.setFont('helvetica', 'bold');
  //          doc.setFontSize(14); // Slightly smaller title for continued pages
  //          doc.setTextColor(0, 0, 0); // Black for continued title
  //          doc.text('EOI Registration Details (Continued)', pageWidth / 2, margin + 10, { align: 'center' });
  //          doc.setDrawColor(0);
  //          doc.line(margin + 5, margin + 20, pageWidth - margin - 5, margin + 20); // Line below continued title
  //          yPos = margin + 30; // Reset Y position for new page, leaving space for new header
  //          doc.setFontSize(10); // Reset font size for data
  //          doc.setTextColor(0, 0, 0); // Ensure text color is black
  //          doc.setFont('helvetica', 'normal'); // Reset font style
  //        }

  //        doc.text(text, xPosContent, yPos);
  //        yPos += lineHeight;
  //      }
  //    }

  //    // Generate a dynamic filename using the Enterprise Name from the form data
  //    const enterpriseName = cleanFormData.EnterpriseName || 'EOI_Registration';
  //    doc.save(`${enterpriseName}_Form_Data.pdf`);
  //    this.toastr.info('Form data downloaded as PDF.');
  //  }).catch(error => {
  //    // Handle errors during image loading or PDF generation
  //    console.error('Error generating PDF (images or content):', error);
  //    this.toastr.error('Failed to generate PDF. Please check image paths or try again.');
  //  });
  //}
  /**
   * Helper function to make field names more readable
   * (e.g., 'UdyamRegistrationNumber' -> 'Udyam Registration Number')
   */
  private formatFieldName(key: string): string {
    return key
      .replace(/([A-Z])/g, ' $1') // Add space before capital letters
      .replace(/_/g, ' ')         // Replace underscores with spaces
      .trim()                     // Trim leading/trailing spaces
      .replace(/^./, str => str.toUpperCase()); // Capitalize first letter
  }


  // 🟢 Helper: Convert camelCase / PascalCase / snake_case to spaced words
  generatePdf(formData: any): void {
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: 'a4',
    });

    const margin = 10;
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;

    // Border
    doc.setDrawColor(0);
    doc.setLineWidth(1);
    doc.rect(margin, margin, pageWidth - 2 * margin, pageHeight - 2 * margin);

    // Logos
    const logo1 = 'assets/Images/RAMP_LOGO.jpg';
    const logo2 = 'assets/Images/logo_icon.png';
    doc.addImage(logo1, 'JPEG', 15, 15, 30, 30);
    doc.addImage(logo2, 'PNG', pageWidth - 45, 15, 30, 30);

    // Titles
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(16);
    doc.setTextColor(197, 41, 42);
    doc.text(
      'Maharashtra Small Scale Industries Development Corporation Ltd.',
      pageWidth / 2,
      25,
      { align: 'center' }
    );

    doc.setFontSize(11);
    doc.setTextColor(0, 0, 0);
    doc.text('A Government Of Maharashtra Undertaking', pageWidth / 2, 32, {
      align: 'center',
    });

    doc.setFontSize(10);
    doc.text('CIN No. U74999MH1962SGC012501', pageWidth / 2, 38, {
      align: 'center',
    });

    // Line
    const lineY = 55;
    doc.line(margin + 5, lineY, pageWidth - margin - 5, lineY);

    // Subtitle
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(14);
    doc.setTextColor(0, 86, 179);
    doc.text('EOI Registration Details', pageWidth / 2, lineY + 10, {
      align: 'center',
    });

    // --- Helper function for key formatting ---
    function formatKey(key: string): string {
      return key
        // Insert space before capital letters
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        // Handle consecutive capitals (like ID, GST, PAN)
        .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
        // Capitalize first letter of each word
        .replace(/\b\w/g, (char) => char.toUpperCase())
        .trim();
    }

    // --- Clean formData ---
    const cleaned: Record<string, any> = {};
    if (formData.enterpriseCode) {
      // Assign to a new key, "EnterpriseCode", for display
      cleaned['EnterpriseCode'] = formData.enterpriseCode;
    }
    for (const key in formData) {
      if (
        formData.hasOwnProperty(key) &&
        !key.endsWith('File') &&
        !key.endsWith('Path') &&
        key !== 'navigationId' &&
        key !== 'DistrictId' &&
        key !== 'enterpriseCode'
      ) {
        let value = formData[key];
        if (typeof value === 'boolean') value = value ? 'Yes' : 'No';
        if (!value) value = 'N/A';
        cleaned[key] = value;
      }
    }

    // --- Convert to 2-column rows ---
    const rows: any[] = [];
    const entries = Object.entries(cleaned);

    for (let i = 0; i < entries.length; i += 2) {
      const col1Key = entries[i] ? formatKey(entries[i][0]) : '';
      const col1Val = entries[i] ? `${entries[i][1]}` : '';
      const col2Key = entries[i + 1] ? formatKey(entries[i + 1][0]) : '';
      const col2Val = entries[i + 1] ? `${entries[i + 1][1]}` : '';

      rows.push([
        { content: col1Key, styles: { fontStyle: 'bold' } },
        { content: col1Val, styles: { fontStyle: 'normal' } },
        { content: col2Key, styles: { fontStyle: 'bold' } },
        { content: col2Val, styles: { fontStyle: 'normal' } },
      ]);
    }

    // --- Table ---
    autoTable(doc, {
      startY: lineY + 20,
      head: [['', '', '', '']],
      body: rows,
      styles: { fontSize: 10, cellPadding: 3 },
      theme: 'grid',
      headStyles: { fillColor: [197, 41, 42], textColor: 255 },
      margin: { left: margin, right: margin },
    });

    // Save PDF
    const enterpriseName = cleaned['EnterpriseName'] || 'EOI_Registration';
    doc.save(`${enterpriseName}_Form_Data.pdf`);
  }

}
